export const SET_ACCESSIBLE_RESOURCES = 'SET_ACCESSIBLE_RESOURCES'
export const SET_FILTERED_RESOURCE_BY_WEEKS = 'SET_FILTERED_RESOURCE_BY_WEEKS'
export const SET_AVERAGE_ATTENDANCE_OFFSET = 'SET_AVERAGE_ATTENDANCE_OFFSET'
export const SET_ACCESSIBLE_INTERACTIONS = 'SET_ACCESSIBLE_INTERACTIONS'
export const SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER'
export const SET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE = 'SET_ENGAGEMENT_SCORE_FOR_ACCESSIBLE'
export const SET_FILTERED_ENGAGEMENT_SCORE_BY_WEEK = 'SET_FILTERED_ENGAGEMENT_SCORE_BY_WEEK'
export const SET_ACCESSIBLE_ATTENDANCE = 'SET_ACCESSIBLE_ATTENDANCE'
export const SET_ACCESSIBLE_MODULE_ATTENDANCE = 'SET_ACCESSIBLE_MODULE_ATTENDANCE'
export const SET_FILTERED_ATTENDANCE = 'SET_FILTERED_ATTENDANCE'
export const SET_FILTERED_MODULE_ATTENDANCE = 'SET_FILTERED_MODULE_ATTENDANCE'
export const SET_ACCESSIBLE_MODULES = 'SET_ACCESSIBLE_MODULES'
export const SET_FILTERED_MODULES = 'SET_FILTERED_MODULES'
export const SET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST = 'SET_STUDENT_ASSESSMENTS_ACCESSIBLE_LIST'
export const CHANGED_FILTER_ON_ACCESSIBLE_ASSESSMENTS = 'CHANGED_FILTER_ON_ACCESSIBLE_ASSESSMENTS'
export const SET_ACCESSIBLE_ASSESSMENTS_LOADING = 'SET_ACCESSIBLE_ASSESSMENTS_LOADING'
export const SET_MODULE_ASSESSMENTS_ACCESSIBLE_LIST = 'SET_MODULE_ASSESSMENTS_ACCESSIBLE_LIST'
export const CHANGED_FILTER_ON_ACCESSIBLE_MODULE_ASSESSMENTS = 'CHANGED_FILTER_ON_ACCESSIBLE_MODULE_ASSESSMENTS'
export const RESET_ACCESSIBLE_ASSESSMENTS = 'RESET_ACCESSIBLE_ASSESSMENTS'
export const RESET_ACCESSIBLE_ATTENDANCE = 'RESET_ACCESSIBLE_ATTENDANCE'
export const RESET_ACCESSIBLE_ENGAGEMENT = 'RESET_ACCESSIBLE_ENGAGEMENT'
export const RESET_ACCESSIBLE_INTERACTIONS = 'RESET_ACCESSIBLE_INTERACTIONS'
export const RESET_ACCESSIBLE_MODULES = 'RESET_ACCESSIBLE_MODULES'
export const RESET_ACCESSIBLE_RESOURCES = 'RESET_ACCESSIBLE_RESOURCES'



// WEBPACK FOOTER //
// ./src/store/modules/accessibility/accessible-mutation-types.js